// extracted by mini-css-extract-plugin
module.exports = {"iconSize":"SocialShare-module--iconSize--2ukmX","root":"SocialShare-module--root--2VMrm"};